import { cap } from '../../../State'
import { translations } from '../../../translations'
import { Icon } from './Icons'
const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Contenuto del dialog per escludere Nora dalla conversazione
 * @param {Object} props
 * @param {Function} props.onHide - Chiude il dialog
 * @param {Function} props.onConfirm - Conferma esclusione
 * @param {boolean} props.callSpinnerEscludiNora - Spinner sul pulsante conferma
 */
export function ModalEscludiNora({ onHide, onConfirm, callSpinnerEscludiNora }) {
  return (
    <>
      <div className="gf-dialog-modal__body gf-dialog-modal__body--compact">
        <div className="gf-dialog-modal__confirm">
          <span className="gf-dialog-modal__icon" aria-hidden="true">
            <Icon name="ban" size={18} />
          </span>
          <div>
            <strong className="gf-dialog-modal__title">{t.gfVuoiEscludereNora}</strong>
            <p className="gf-dialog-modal__sub">{t.gfEscludiNoraSub}</p>
          </div>
        </div>
      </div>
      <div className="gf-dialog-modal__footer">
        <button type="button" className="gf-btn" onClick={onHide} disabled={callSpinnerEscludiNora}>
          {t.annulla}
        </button>
        <button
          type="button"
          className="gf-btn gf-btn--danger"
          onClick={onConfirm}
          disabled={callSpinnerEscludiNora}
        >
          {callSpinnerEscludiNora ? <span className="gf-btn__spinner" aria-hidden="true" /> : null}
          {t.conferma}
        </button>
      </div>
    </>
  )
}
